window.dataLayer = window.dataLayer || [];

import { clickHandler, determineActionText } from '@/scripts/analytics/analytics.methods';

const eventName = 'iconBlock_tracking';
const actionPropTitle = 'iconBlock_action';
const labelPropTitle = 'iconBlock_label';

const iconBlockCards = [...document.getElementsByClassName('js-icon-block-item-ga')];

function bindEventListener(el, cardTitle) {
  el.addEventListener(
    'click',
    clickHandler.bind(this, {
      event: eventName,
      actionProp: actionPropTitle,
      labelProp: labelPropTitle,
      action: `Click ${determineActionText(el)} - ${cardTitle}`,
      label: queryURL(el),
    }),
  );
}

function queryURL(el) {
  const url = el.getAttribute('href');
  return url ? url : '';
}

function init() {
  if (!iconBlockCards.length) {
    return;
  }

  iconBlockCards.forEach((card) => {
    const cardTitle = card.querySelector('.js-icon-block-title-ga')?.innerText || 'No Title';
    const cardLink = card.querySelector('.js-icon-block-btn-ga');
    if (!cardLink) return;
    bindEventListener(cardLink, cardTitle);
  });
}

export default init;
